export const FIND_DOCUMENTS_REQUEST = 'FIND_DOCUMENTS_REQUEST';

export const findDocumentsRequest = ({
     filter = [],
     sorting = { field: 'originalname', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_DOCUMENTS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
        pagination,
    }
});
